module.exports = __webpack_public_path__ + "img/newsletter-top.31fb2bb.png";